import { useQuery } from "@tanstack/react-query";
import { useAnalytics } from "../../../../contexts/analytics/hooks";
import { useChosenDepartment } from "../../../../contexts/ChosenDepartment";
import { backendService } from "../../../../services/backend.service";
import type { HiringGridCoord, HiringStaffedNursesResponse } from "../types";

export const HIRING_STAFFED_NURSES_QUERY_KEY = "hiring-staffed-nurses";

type Args = {
	coord: HiringGridCoord | null;
	jobId: string | null;
	enabled: boolean;
};

export function useHiringStaffedNurses({ coord, jobId, enabled }: Args) {
	const { chosenDepartment } = useChosenDepartment();
	const { track, trackError } = useAnalytics();

	return useQuery<HiringStaffedNursesResponse>({
		queryKey: [HIRING_STAFFED_NURSES_QUERY_KEY, chosenDepartment.department_id, jobId, coord?.weekIdx, coord?.dayIdx, coord?.shiftLabel],
		queryFn: async () => {
			if (!coord || !jobId) {
				throw new Error("missing_coord_or_job");
			}
			track("hiring_staffed_nurses_fetch_start", { department_id: chosenDepartment.department_id, job_id: jobId });
			try {
				const { data } = await backendService.getHiringStaffedNurses(chosenDepartment.department_id, {
					dayIdx: coord.dayIdx,
					weekIdx: coord.weekIdx,
					shiftLabel: coord.shiftLabel,
					jobId,
				});
				track("hiring_staffed_nurses_fetch_success", { count: data.staff.length });
				return data;
			} catch (err) {
				const message = err instanceof Error ? err.message : "unknown";
				trackError("hiring_staffed_nurses_fetch_error", { error_message: message });
				throw err;
			}
		},
		enabled: enabled && Boolean(coord) && Boolean(jobId),
	});
}
